import { useMutation } from "@tanstack/vue-query";
import { GeneratePedidoPdfAction } from "../actions";
import { useToast } from "vue-toastification";

export function useGeneratePedidoPdf() {
  const toast = useToast();
  const mutation = useMutation({
    mutationFn: (pedidoId: string) => GeneratePedidoPdfAction(pedidoId),
    onSuccess: () => {
      toast.success("PDF descargado correctamente");
    },
    onError: () => {
      toast.error("Error al generar el PDF");
    },
  });

  return {
    ...mutation, // => { mutate, mutateAsync, isPending, isError, error, isSuccess, data }
  };
}